module.exports = __webpack_public_path__ + "img/805-964aa0.png";